<template>
    <section class="scrollable">
        <h3 class="section-title">Рецепты {{ id }}</h3>

        <div class="recipes-wrap recipes-wrap__single">
            <div class="recipes-container">

                <div class="recipe-button">
                    <router-link class="btn-back" to="/recipes" @click.native = "gaBack"><Arrow></Arrow>Вернуться</router-link>
                </div>

                <div class="recipes-info">
                    <span class="recipes-name">{{RecipeItem.name}}</span>
                    <span class="recipes-portions">{{RecipeItem.portion}}</span>
                    <span class="recipes-time">{{RecipeItem.time}}</span>
                </div>
                <div class="recipe-image">
                    <img :src=" RecipeItem.image  " alt="Recipe Image">
                </div>
                <div class="recipe-block">
                    <h3 class="title">
                        Ингридиенты:
                    </h3>
                    <ul class="list">

                      <li v-for="(item, index) in RecipeItem.ingredients" :key="index">
                        <span class="name left">{{item.text}}</span>
                        <span class="value right">{{item.value}}</span>
                      </li>
                    </ul>
                </div>
                <div class="recipe-block">
                    <h3 class="title">
                        Инструкция приготовления:
                    </h3>
                    <ol class="instruction">
                      <li v-for="(item, index) in RecipeItem.instruction" :key="index">
                        <span>{{item.text}}</span>
                      </li>

                    </ol>
                </div>

                <div class="recipe-button">
                    <router-link class="btn-back mobile-hidden" to="/recipes" @click.native = "gaBack"><Arrow></Arrow>Вернуться</router-link>
                    <a class="btn-top desktop-hidden" @click.prevent="scrollTop"><span>В начало</span><Arrow></Arrow></a>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    import {TweenMax} from 'gsap';
    import Arrow from '../../assets/svg/arrow.svg';
    import Recipe from '@/components/common/Recipe';
    import Storage from '@/store/storage';
    import Helpers from '@/tools/Helpers';

    export default {

        name: 'RecipeItem',

        props: ['recipe','index'],

        mounted(){
            document.body.scrollTop = 0;

            function hideTitle() {

                if(Helpers.isMobile()){
                    return
                }

                var scrolled = window.pageYOffset || document.documentElement.scrollTop;
                if(scrolled>0){
                    document.querySelector('.menu-btn.left').classList.add('hide');
                }else{
                    document.querySelector('.menu-btn.left').classList.remove('hide');
                }
            };


            window.onscroll = function() {
                hideTitle()
            }

        },

        methods: {
            scrollTop(){
                document.body.scrollTop = 0;
            },
            gaBack(){
                ga('send', 'event', 'click', 'show', 'Click Back button')
            }
        },
        data() {
            return {
                id: this.$route.params.id,
                RecipeItem: this.$store.state.RecipeDate[this.$route.params.id]
            }
        },
        created () {
//            console.log(this.$route.params.slug);
//            this.recipe = this.Recipes[0];

        },
        components: {
            Arrow
        }


    }
</script>



// WEBPACK FOOTER //
// RecipeItem.vue?efeef8de